import { apiClient } from "./client";

export type SourceType =
  | "web_cabinet_utp"
  | "rtu530_iec104"
  | "rtu530_modbus"
  | "rdn_prices"
  | "imbalance_prices"
  | "gas_web_cabinet"
  | "gas_imod_vega"
  | "gas_fallback_empirical"
  | "heat_web_cabinet";

export const SOURCE_TYPES: SourceType[] = [
  "web_cabinet_utp",
  "rtu530_iec104",
  "rtu530_modbus",
  "rdn_prices",
  "imbalance_prices",
  "gas_web_cabinet",
  "gas_imod_vega",
  "gas_fallback_empirical",
  "heat_web_cabinet",
];

export interface Source {
  id: string;
  tenant_id: string;
  name: string;
  type: SourceType;
  url: string | null;
  host: string | null;
  port: number | null;
  login: string | null;
  poll_interval_min: number;
  retry_count: number;
  config: Record<string, unknown> | null;
  is_active: boolean;
  last_success_at: string | null;
  last_failure_at: string | null;
  consecutive_failures: number;
  created_at: string;
  has_password: boolean;
}

export interface SourceCreate {
  name: string;
  type: SourceType;
  url?: string | null;
  host?: string | null;
  port?: number | null;
  login?: string | null;
  password?: string | null;
  poll_interval_min?: number;
  retry_count?: number;
  config?: Record<string, unknown> | null;
  is_active?: boolean;
}

export type SourceUpdate = Partial<SourceCreate>;

export interface SourceTestResult {
  ok: boolean;
  message: string;
}

export const sourcesApi = {
  list: () => apiClient.get<Source[]>("/sources").then((r) => r.data),
  create: (body: SourceCreate) =>
    apiClient.post<Source>("/sources", body).then((r) => r.data),
  update: (id: string, body: SourceUpdate) =>
    apiClient.put<Source>(`/sources/${id}`, body).then((r) => r.data),
  remove: (id: string) =>
    apiClient.delete<{ ok: boolean }>(`/sources/${id}`).then((r) => r.data),
  test: (id: string) =>
    apiClient.post<SourceTestResult>(`/sources/${id}/test`).then((r) => r.data),
  runNow: (id: string) =>
    apiClient
      .post<{ ok: boolean; queued: boolean; note?: string }>(`/sources/${id}/run-now`)
      .then((r) => r.data),
};
